import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";
import { fetchBookingLocations } from '../actions/locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { addActualsToBooking, saveAddresses, updateDriverQueue } from "../other/sharedFunctions";
import { get, onValue, update, off, remove, push, runTransaction } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

let trackedBookingId = null;

const currentDriverLocation = (booking, fallback) => {
  const loc = store.getState().gpsdata.location;
  if (loc && typeof loc.lat === 'number' && typeof loc.lng === 'number') return loc;
  const point = booking[fallback] || {};
  return { lat: point.lat, lng: point.lng };
};

export const fetchBookings = () => (dispatch) => {

  const {
    bookingListRef,
  } = firebase;

  dispatch({
    type: FETCH_BOOKINGS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;
  if (!userInfo || !userInfo.uid) {
    dispatch({ type: FETCH_BOOKINGS_FAILED, payload: store.getState().languagedata.defaultLanguage.no_bookings });
    return;
  }

  off(bookingListRef(userInfo.uid, userInfo.usertype));
  onValue(bookingListRef(userInfo.uid, userInfo.usertype),(snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const active = [];
      let tracked = null;
      const bookings = Object.keys(data)
        .map((i) => {
          data[i].id = i;
          data[i].pickupAddress = data[i].pickup ? data[i].pickup.add : '';
          data[i].dropAddress = data[i].drop ? data[i].drop.add : '';
          data[i].discount = data[i].discount
            ? data[i].discount
            : 0;
          data[i].cashPaymentAmount = data[i].cashPaymentAmount
            ? data[i].cashPaymentAmount
            : 0;
          data[i].cardPaymentAmount = data[i].cardPaymentAmount
            ? data[i].cardPaymentAmount
            : 0;
          return data[i];
        });
      for (let i = 0; i < bookings.length; i++) {
        if (['PAYMENT_PENDING','NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID'].indexOf(bookings[i].status) != -1) {
          active.push(bookings[i]);
        }
        if ((['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(bookings[i].status) != -1) && userInfo.usertype == 'driver') {
          tracked = bookings[i];
        }
      }
      // Un seul abonnement de suivi par course (auparavant recréé à chaque mise à jour de la liste).
      if (tracked && tracked.id !== trackedBookingId) {
        trackedBookingId = tracked.id;
        fetchBookingLocations(tracked.id)(dispatch);
      } else if (!tracked) {
        trackedBookingId = null;
      }
      dispatch({
        type: FETCH_BOOKINGS_SUCCESS,
        payload: {
          bookings: bookings.reverse(),
          active: active,
          tracked: tracked
        },
      });
      if (tracked) {
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: null
        });
      }
    } else {
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_bookings,
      });
    }
  });
};

// Écriture envoyée sans bloquer l'écran (hors ligne elle part à la reconnexion) ; erreurs journalisées.
const fire = (p) => (p && typeof p.catch === 'function' ? p.catch((e) => console.warn('booking write', e)) : p);

const updateBookingInner = (booking) => async (dispatch) => {

  const {
    auth,
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
    userRatingsRef
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  
  if (booking.status == 'PAYMENT_PENDING') {
    fire(update(singleBookingRef(booking.id),booking));
  }
  if (booking.status == 'NEW' || booking.status == 'ACCEPTED') {
    fire(update(singleBookingRef(booking.id), updateDriverQueue(booking)));
  }
  if (booking.status == 'ARRIVED') {
    let dt = new Date();
    booking.driver_arrive_time = dt.getTime().toString();
    fire(update(singleBookingRef(booking.id),booking));
    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_near,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }
  }
  
  if (booking.status == 'STARTED') {
    let dt = new Date();
    let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    let timeString = dt.getTime();
    booking.trip_start_time = localString;
    booking.startTime = timeString;
    fire(update(singleBookingRef(booking.id),booking));

    const driverLocation = currentDriverLocation(booking, 'pickup');
    
    fire(push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'STARTED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    }));

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_journey_msg + booking.reference,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
      }
   }

  if (booking.status == 'REACHED') {

    const driverLocation = currentDriverLocation(booking, 'drop');

    fire(push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    }));

    let address = await saveAddresses(booking,driverLocation);

    let bookingObj = await addActualsToBooking(booking, address, driverLocation);
    fire(update(singleBookingRef(booking.id),bookingObj));

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }
  }

  if (booking.status == 'PENDING') {
    fire(update(singleBookingRef(booking.id),booking));
    fire(update(singleUserRef(booking.driver), { queue: false }));
  }
  if (booking.status == 'PAID') {
    if(booking.booking_from_web){
      booking.status = 'COMPLETE';
    }
    fire(update(singleBookingRef(booking.id), booking));
    if(booking.driver == auth.currentUser.uid && (booking.prepaid || booking.payment_mode == 'cash' || booking.payment_mode == 'wallet')){
      fire(update(singleUserRef(booking.driver), { queue: false }));
    }

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.success_payment,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
    }

  if (booking.status == 'COMPLETE') {
    // Fin de course : le chauffeur est libéré tout de suite, sans attendre l'avis du client.
    if (booking.driver && auth.currentUser && booking.driver === auth.currentUser.uid) {
      fire(update(singleUserRef(booking.driver), { queue: false }));
      if (booking.customer_token) {
        RequestPushMsg(booking.customer_token, {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.success_payment,
          screen: 'RideList',
        });
      }
    }
    fire(update(singleBookingRef(booking.id), booking));
    if (booking.rating) {
      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg:  store.getState().languagedata.defaultLanguage.received_rating.toString().replace("X", booking.rating.toString()),
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
      // Moyenne et nombre d'avis calculés côté serveur (Cloud Function updateBooking).
    }
  }
};

// Annulation en transaction : impossible d'annuler une course déjà démarrée, terminée ou
// annulée au même moment par l'autre partie. Si le chauffeur annule une course acceptée,
// elle repasse en recherche ("NEW") pour trouver automatiquement un autre chauffeur.
// Toute transition de statut passe ici : les écritures partent sans bloquer (success = envoyée), une erreur ne remonte jamais à l'écran.
export const updateBooking = (booking) => async (dispatch) => {
  try {
    await updateBookingInner(booking)(dispatch);
    return { success: true };
  } catch (error) {
    console.warn('updateBooking error:', error);
    return { success: false, error };
  }
};

export const cancelBooking = (data) => async (dispatch) => {
  const { singleBookingRef, singleUserRef, requestedDriversRef } = firebase;
  const CANCELLABLE = ['PAYMENT_PENDING', 'NEW', 'ACCEPTED', 'ARRIVED'];
  let requeued = false;

  dispatch({ type: CANCEL_BOOKING, payload: data });

  try {
    const result = await runTransaction(singleBookingRef(data.booking.id), (booking) => {
      if (booking === null) return booking;
      if (!booking.status || CANCELLABLE.indexOf(booking.status) === -1) return;

      if (data.cancelledBy === 'driver' && booking.driver && ['ACCEPTED', 'ARRIVED'].indexOf(booking.status) !== -1) {
        requeued = true;
        const now = Date.now();
        booking.previousDriverId = booking.driver;
        booking.previousDriverCancelledAt = now;
        booking.cancelledDriverIds = { ...(booking.cancelledDriverIds || {}), [booking.driver]: now };
        booking.status = 'NEW';
        ['driver', 'driver_image', 'car_image', 'driver_name', 'driver_contact', 'driver_token', 'vehicle_number',
          'vehicleModel', 'vehicleMake', 'driverRating', 'acceptedAt', 'acceptedBy', 'requestedDrivers', 'driverEstimates']
          .forEach((k) => { booking[k] = null; });
        booking.driverCancellationReason = data.reason;
        return booking;
      }

      booking.status = 'CANCELLED';
      booking.reason = data.reason;
      booking.cancelledBy = data.cancelledBy;
      booking.cancellationRequestedAt = Date.now();
      booking.requestedDrivers = null;
      return booking;
    });

    if (!result.committed || !result.snapshot.exists()) {
      return { success: false };
    }
    const booking = { ...result.snapshot.val(), id: data.booking.id };
    const previousDriverId = requeued ? booking.previousDriverId : booking.driver;
    if (previousDriverId) update(singleUserRef(previousDriverId), { queue: false }).catch(() => null);
    if (!requeued) remove(requestedDriversRef(booking.id)).catch(() => null);

    const lang = store.getState().languagedata.defaultLanguage || {};
    if (data.booking.driver_token && data.cancelledBy !== 'driver') {
      RequestPushMsg(data.booking.driver_token, {
        title: lang.notification_title,
        msg: (lang.booking_cancelled || 'Course annulée ') + booking.id,
        screen: 'DriverTrips',
      });
    }
    if (booking.customer_token && data.cancelledBy !== 'customer') {
      RequestPushMsg(booking.customer_token, {
        title: lang.notification_title,
        msg: requeued
          ? 'Votre chauffeur a annulé la course. Nous recherchons un nouveau chauffeur pour vous.'
          : (lang.booking_cancelled || 'Course annulée ') + booking.id,
        screen: 'BookedCab',
        params: { bookingId: booking.id },
      });
    }
    return { success: true, requeued };
  } catch (error) {
    console.warn('cancelBooking error:', error);
    return { success: false, error };
  }
};

export const updateBookingImage = (booking, imageType, imageBlob) => (dispatch) => {
  const   {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  uploadBytesResumable(bookingImageRef(booking.id,imageType), imageBlob).then(() => {
    if (imageBlob && typeof imageBlob.close === 'function') imageBlob.close();
    return getDownloadURL(bookingImageRef(booking.id,imageType))
  }).then((url) => {
    if(imageType == 'pickup_image'){
      booking.pickup_image = url;
    }
    if(imageType == 'deliver_image'){
      booking.deliver_image = url;
    }
    update(singleBookingRef(booking.id), booking);
    dispatch({
      type: UPDATE_BOOKING,
      payload: booking,
    });
  })
};

export const forceEndBooking = (booking) => async (dispatch) => {

  const {
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });
  
  if (booking.status == 'STARTED') {

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: booking.drop.lat,
      lng: booking.drop.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    update(singleUserRef(booking.driver),{ queue: false });

    if(booking.prepaid){

      const settingsdata = await get(settingsRef);
      const settings = settingsdata.val();

      onValue(singleUserRef(booking.driver), snapshot => {
        let walletBalance = parseFloat(snapshot.val().walletBalance);
        walletBalance = walletBalance + parseFloat(booking.driver_share);
        if(parseFloat(booking.cashPaymentAmount)>0){
          walletBalance = walletBalance - parseFloat(booking.cashPaymentAmount);
        }
        update(singleUserRef(booking.driver),{"walletBalance": parseFloat(walletBalance.toFixed(settings.decimal))});

        let details = {
          type: 'Credit',
          amount: parseFloat(booking.driver_share).toFixed(settings.decimal),
          date: new Date().getTime(),
          txRef: booking.id
        }
        push(walletHistoryRef(booking.driver),details);
        
        if(parseFloat(booking.cashPaymentAmount)>0){
          let details = {
            type: 'Debit',
            amount: booking.cashPaymentAmount,
            date: new Date().getTime(),
            txRef: booking.id
          }
          push(walletHistoryRef(booking.driver), details);
        }  
      },{onlyOnce: true});

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }

      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
        }
      booking.status = 'PAID';
    } else{
      booking.status = 'PENDING';
    }

    update(singleBookingRef(booking.id), booking);
  }
};